
const detail = {
  path: 'detail/:id',
  component: resolve => require(['../../../../../pages/modules/news/detail'], resolve),
}

export default detail
